import "./App.css";
import "./fonts.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AuthProvider from "./context/AuthContext";
import ProfileProvider from "./context/ProfileContext";
import OrderProvider from "./context/OrderContext";
import CartProvider from "./context/CartContext";
import OrderProcessingProvider from "./context/OrderProcessingContext";
import FamilyProvider from "./context/FamilyContext";
import AddressProvider from "./context/AddressContext";
import TestProvider from "./context/TestContext";
import BottomNavbarProvider from "./context/BottomNavBarContext";

// Imports
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import MyProfile from "./pages/MyProfile";
import MyOrder from "./pages/MyOrder";
import FamilyMember from "./pages/FamilyMember";
import MyAddress from "./pages/MyAddress";
import Support from "./pages/Support";
import RiskBasedTesting from "./pages/RiskBasedTesting";
import Labs from "./pages/Labs";
import LabSpecific from "./pages/LabSpecific";
import Cart from "./pages/Cart";
import Search from "./pages/Search";
import ThankYou from "./pages/ThankYou";
import PageNotFound from "./pages/PageNotFound";
import ProtectedRoute from "./components/ProtectedRoute";
import ResetPassword from "./pages/ResetPassword";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import AccountInfoDeletion from "./pages/AccountInfoDeletion";
import NewsPrivacyPolicy from "./pages/NewsPrivacyPolicy";
import NewsAccountDeletionInfo from "./pages/NewsAccountInfoDeletion";
import Blog from "./pages/Blog";
import ProductDetails from "./pages/ProductDetails";
import BlogDetails from "./pages/BlogDetails";
import NewsContactUs from "./pages/NewsContactUs";
import BitesInfo from "./pages/BitesInfo";
import Appointments from "./pages/Appointments";
const App = () => {
	return (
		<Router>
			<BottomNavbarProvider>
				<AuthProvider>
					<ProfileProvider>
						<FamilyProvider>
							<AddressProvider>
								<TestProvider>
									<CartProvider>
										<OrderProcessingProvider>
											<OrderProvider>
												<Routes>
													{/** Public Routes */}
													<Route path='/' element={<Home />} />
													<Route path='/blogs' element={<Blog />} />
													<Route path='/blog/:slug' element={<BlogDetails />} />
													<Route path='/contact-us' element={<ContactUs />} />
													<Route path='/about-us' element={<AboutUs />} />
													<Route path='/labs/:id' element={<Labs />} />
													<Route
														path='/reset-password/:resetToken'
														element={<ResetPassword />}
													/>
													c
													<Route
														path='/lab/:brandName/:filterByBodyPart'
														element={<LabSpecific />}
													/>
													<Route
														path='/risk-based-testing/:filterData'
														element={<RiskBasedTesting />}
													/>
													<Route path='/search' element={<Search />} />
													<Route path='/cart' element={<Cart />} />
													{/* <Route path='/cart2' element={<Cart2 />} /> */}
													
													<Route
														path='/payment/thank-you'
														element={<ThankYou />}
													/>
													<Route path='*' element={<PageNotFound />} />
													{/** Protected Routes */}
													<Route
														path='/my-profile'
														element={
															<ProtectedRoute>
																<MyProfile />
															</ProtectedRoute>
														}
													/>
													<Route
														path='/my-order'
														element={
															<ProtectedRoute>
																<MyOrder />
															</ProtectedRoute>
														}
													/>
													<Route
														path='/family-member'
														element={
															<ProtectedRoute>
																<FamilyMember />
															</ProtectedRoute>
														}
													/>
													<Route
														path='/my-address'
														element={
															<ProtectedRoute>
																<MyAddress />
															</ProtectedRoute>
														}
													/>
													<Route
														path='/support'
														element={
															<ProtectedRoute>
																<Support />
															</ProtectedRoute>
														}
													/>
													<Route
														path='/privacy-policy'
														element={<PrivacyPolicy />}
													/>
													<Route
														path='/product-details/:productId'
														element={<ProductDetails />}
													/>
													<Route
														path='/account-deletion-info'
														element={<AccountInfoDeletion />}
													/>
													{/* bites specific routes */}
													<Route
														path='/bites/privacy-policy'
														element={<NewsPrivacyPolicy />}
													/>
													<Route
														path='/bites/account-deletion-info'
														element={<NewsAccountDeletionInfo />}
													/>
													<Route
														path='/bites/contact-us'
														element={<NewsContactUs />}
													/>
													<Route path='/bites' element={<BitesInfo />} />
													
												</Routes>
											</OrderProvider>
										</OrderProcessingProvider>
									</CartProvider>
								</TestProvider>
							</AddressProvider>
						</FamilyProvider>
					</ProfileProvider>
				</AuthProvider>
			</BottomNavbarProvider>
		</Router>
	);
};

export default App;
